// extracted by mini-css-extract-plugin
module.exports = {"jds-MenuItem":"MenuItem_jds-MenuItem__MRXWJ","jds-MenuItem--selected":"MenuItem_jds-MenuItem--selected__91sFZ"};